export default __webpack_public_path__ + "static/media/twinbed3.b296676c.jpg";